import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
  Moeda
} from '../../../enums/moeda.enum';
import { TipoTransacao } from '../../../enums/TipoTransacao.enum';
import { environment } from '../../../environments/environment';
import { PessoaDTO } from '../../../models/clientes/pessoa.model';
import {
  MoedaDTO
} from '../../../models/configuracoes/empresa.model';
import { ItemDTO } from '../../../models/item.model';
import { ItemDeNotaDTO, ItemDeNotaFormDTO, NotaDTO } from '../../../models/nota.model';
import { EmpresaConfigService } from '../../../services/configuracoes/empresa.service';
import { CotacaoGuardService } from '../../../services/cotacao/cotacao-guard.service';
import { CotacaoService } from '../../../services/cotacao/cotacao.service';
import { PessoaService } from '../../../services/pessoas/pessoas.service';
import { UsuarioService } from '../../../services/usuario/usuario.service';
import { SafeStorageService } from '../../../shared/safe-storage.service';
import { ContaService } from '../../../services/conta/conta.service';
import { TranslateService } from '@ngx-translate/core';
import { FormaPagamentoResult, DadosPagamentoDinheiro, DadosPagamentoConta, DadosPagamentoPrazo } from '../../../shared/components/forma-pagamento-dialog/forma-pagamento-dialog.interfaces';
import { NotaService } from '../../../services/financeiro/notas.service';
import { toLocalISOString } from '../../../shared/utils/date-utils';
import { converterDireto, ConversaoNaoPermitidaError } from '../../../shared/utils/moeda-conversao.util';
import { enumMoedaParaIso, podeConverterEntre } from '../../../utils/moeda-pareamento.util';
import { EntitySelectorComponent } from '../../../shared/components/entity-selector/entity-selector.component';
import { EntitySelectorConfig } from '../../../shared/components/entity-selector/entity-selector.interfaces';
import { PermissaoService } from '../../../services/permissao/permissao.service';
import { ItemsService } from '../../../services/financeiro/item.service';
import { firstValueFrom, forkJoin, of } from 'rxjs';


@Component({
  selector: 'app-fornecedor-compra',
  templateUrl: './fornecedor-compra.component.html',
  styleUrl: './fornecedor-compra.component.scss',
  providers: [ConfirmationService, MessageService],
})
export class FornecedorCompraComponent implements OnInit, OnDestroy {
  @ViewChild('fornecedorSelector') fornecedorSelector!: EntitySelectorComponent;
  @ViewChild('btnImprimirCompra') btnImprimirCompra?: ElementRef<HTMLButtonElement>;

  env = environment;

  // fornecedor
  visibleAddFornecedor: boolean = false;
  selectedFornecedor: PessoaDTO | undefined;

  // Configuracao do entity-selector para fornecedor
  fornecedorSelectorConfig!: EntitySelectorConfig;

  // Produtos
  visibleSelectItems: boolean = false;
  selectedItems: ItemDeNotaFormDTO[] = [];

  // Indice do item em edicao (usado para evitar colisao ao atualizar itens duplicados)
  private editandoItemIdx: number = -1;


  faturaLegal: string[] = [];
  onLabel = 'Fatura legal';

  // Propriedades do diálogo
  mostrarDialogPagamento = false; // Controla a visibilidade do dialog
  formaPagamentoSelecionada: string | null = null; // Armazena a forma de pagamento selecionada
  // moedaPadrao: string = 'BRL'; // Valor padrão inicial
  idEmpresa: string = '';
  localeMoeda: string = 'pt-BR'; // Locale padrão
  valorRecebidoEmGuarani: number = 0;
  valorRecebidoEmDolar: number = 0;
  valorRecebidoEmReal: number = 0;
  contaSelecionada: any = null; // Conta selecionada no dropdown
  informacaoDaTransacao: string = ''; // Informação da transação
  itemParaEditar: ItemDeNotaDTO | undefined;
  moedaPadrao: MoedaDTO | undefined;

  // Propriedades para o componente de pagamento
  // Suporta ARS (Peso Argentino) alem das moedas legadas
  moedaPadraoISO: 'BRL' | 'PYG' | 'USD' | 'ARS' = 'BRL';
  cotUSD = 1;
  cotPYG = 7180;
  cotBRL = 5.47;
  /** Cotacao Peso Argentino em Guaranis (1 ARS = N PYG). 0 = peso desabilitado. */
  cotPesoGuarani = 0;
  /** Cotacao direta BRL->PYG (1 BRL = N PYG). 0 = triangulacao via USD. */
  cotRealGuarani = 0;
  contasFormatadas: { label: string; value: any }[] = [];
  processandoCompra = false;

  // Dialogo Fatura Pos-Compra
  mostrarDialogoFatura = false;
  notaCarregada: NotaDTO | null = null;
  itensCarregados: ItemDTO[] = [];
  carregandoFatura = false;
  opcaoImpressaoFatura = 'BOBINA_58';
  isImprimindoFatura = false;

  // Opcao de impressao automatica da empresa
  private tipoImprimir: string = 'PERGUNTAR';

  notaForm: Partial<NotaDTO> = this.createEmptyNotaForm();

  activeDropdown: 'fornecedor' | 'produto' | null = null;

  constructor(
    private messageService: MessageService,
    private empresaConfigService: EmpresaConfigService,
    private cdr: ChangeDetectorRef,
    private cotacaoService: CotacaoService,
    private cotacaoGuard: CotacaoGuardService,
    private confirmationService: ConfirmationService,
    private usuarioService: UsuarioService,
    private pessoaService: PessoaService,
    private safe: SafeStorageService,
    private contaService: ContaService,
    private translate: TranslateService,
    private notaService: NotaService,
    private permissaoService: PermissaoService,
    private router: Router,
    private itemsService: ItemsService,
  ) { }


  // HOTKEYS
  @HostListener('document:keydown', ['$event'])
  onGlobalKeydown(ev: KeyboardEvent) {
    // Se o dialog de pagamento esta aberto, nao interceptar atalhos aqui
    // (o proprio componente forma-pagamento-dialog gerencia seus atalhos)
    if (this.mostrarDialogPagamento) return;

    // Dialogo de fatura pos-compra
    if (this.mostrarDialogoFatura) {
      if (ev.key === 'Escape') {
        ev.preventDefault();
        this.fecharDialogoFatura();
        return;
      }
      if (ev.ctrlKey && ev.key === 'p') {
        ev.preventDefault();
        this.gerarPdfFaturaDialog();
        return;
      }
      return;
    }

    // Escape: fechar dialogs abertos (prioridade maxima)
    if (ev.key === 'Escape') {
      if (this.visibleAddFornecedor) {
        ev.preventDefault();
        this.showAddFornecedor(false);
        return;
      }
      if (this.visibleSelectItems) {
        ev.preventDefault();
        this.showSelectItems(false);
        return;
      }
      return;
    }

    // Ctrl+Enter: acao depende do contexto
    if (ev.ctrlKey && ev.key === 'Enter') {
      ev.preventDefault();

      // Se nenhum dialog aberto, finalizar pedido (Realizar Compra)
      if (this.nenhumDialogAberto()) {
        this.finalizarPedido();
        return;
      }
      return;
    }

    // Ctrl+Shift+Delete: cancelar pedido (apenas se nenhum dialog aberto)
    if (ev.ctrlKey && ev.shiftKey && ev.key === 'Delete') {
      if (this.nenhumDialogAberto()) {
        ev.preventDefault();
        this.abrirConfirmacaoCancelarPedido();
        return;
      }
    }

    // F9: abrir dialog de novo fornecedor
    if (ev.key === 'F9') {
      ev.preventDefault();
      this.showAddFornecedor(true);
      return;
    }

    // Modal de Fornecedor ou Produto (F3)
    if (ev.key === 'F3') {
      ev.preventDefault();

      // Verificar se o foco esta no autocomplete do fornecedor
      const focusInFornecedor = this.activeDropdown === 'fornecedor'
        || document.activeElement?.closest('app-entity-selector') != null;

      if (focusInFornecedor) {
        this.fornecedorSelector.openDialog();
        this.activeDropdown = null;
      } else if (!this.visibleSelectItems) {
        this.showSelectItems(true);
      }
    }
  }

  /** Verifica se nenhum dialog esta aberto */
  private nenhumDialogAberto(): boolean {
    return !this.mostrarDialogPagamento
      && !this.visibleAddFornecedor
      && !this.visibleSelectItems;
  }


  ngOnInit() {
    // Obtém o idEmpresa do sessionStorage
    this.idEmpresa = this.safe.getItem('id') || '';

    this.carregarMoedaPadrao();
    this.carregarContas();

    // Configuracao do entity-selector para fornecedor
    // showAddInDropdown somente se o usuario tiver permissao de cadastrar fornecedores
    this.fornecedorSelectorConfig = {
      categoryFilter: 'categoriaFornecedor=true',
      placeholder: this.translate.instant('fornecedor-compra.placeholders.buscar_fornecedor'),
      labelIcon: 'pi pi-users',
      labelIconClass: 'contact-color',
      showAddButton: false,
      showAddInDropdown: this.permissaoService.temPermissao('fornecedor'),
      dialogTitle: this.translate.instant('fornecedor-compra.labels.selecionar_fornecedor'),
      dialogIcon: 'pi pi-users',
    };
  }

  ngOnDestroy() {
    // Nada a limpar
  }

  createEmptyNotaForm(): Partial<NotaDTO> {
    return {
      emissao: toLocalISOString(),
      dataDeCompra: new Date(),
      tipoDeTransacao: TipoTransacao.COMPRA,
      ehFaturaLegal: false,
      numeroFatura: undefined,
      condicaoDePagamento: undefined,
      cotacao_id: undefined,
      valorDoDesconto: 0,
      porcentagemDesconto: 0,
      valorTotalComDesconto: 0,
      moeda: undefined,
      cancelado: false,
      baixas: [],
      titulos: [],
    };
  }

  // fornecedor
  get fornecedorNome(): string {
    return this.selectedFornecedor?.nome || '';
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/profile_placeholder.png';
  }

  // =========================================================================
  // Dialog de Visualizacao de Imagens do Item (carrossel)
  // =========================================================================

  /** Item cujas imagens estao sendo visualizadas no dialog (null = fechado). */
  itemImagensSelecionado: ItemDTO | null = null;

  abrirImagensDoItem(item: ItemDTO): void {
    this.itemImagensSelecionado = item;
  }

  fecharImagensDoItem(): void {
    this.itemImagensSelecionado = null;
  }

  // Two-way binding do p-dialog: o setter para `false` (botao X / Esc) fecha o
  // dialog limpando o item selecionado.
  get imagensDialogVisible(): boolean {
    return !!this.itemImagensSelecionado;
  }

  set imagensDialogVisible(value: boolean) {
    if (!value) {
      this.itemImagensSelecionado = null;
    }
  }

  get isFaturaLegal(): boolean {
    return this.faturaLegal.includes('faturaLegal');
  }

  onFaturaLegalChange(): void {
    this.notaForm.ehFaturaLegal = this.isFaturaLegal;
  }

  showAddFornecedor(visible: boolean) {
    this.visibleAddFornecedor = visible;
  }

  addFornecedor(fornecedorSelecionado: PessoaDTO) {
    this.selectedFornecedor = fornecedorSelecionado;
  }

  /** Handler: fornecedor novo cadastrado via PessoaAdicionarDialogComponent.
   *  Seleciona automaticamente o fornecedor recem-criado, igual ao comportamento
   *  de pessoaVinculada que chama addFornecedor.
   */
  onFornecedorCriado(pessoa: PessoaDTO): void {
    this.addFornecedor(pessoa);
  }

  // Items Adicionar a nota
  showSelectItems(visible: boolean, item?: any) {
    if (item && item.itemDeNotaDTO && item.item) {
      // Modo edição: preencher com dados do item e salvar o indice para updateItem
      this.itemParaEditar = {
        ...item.itemDeNotaDTO,
        item: item.item
      };
      this.editandoItemIdx = this.selectedItems.indexOf(item);
    } else {
      // Modo novo: limpar para abrir em branco
      this.itemParaEditar = undefined;
      this.editandoItemIdx = -1;
    }
    this.visibleSelectItems = visible;
  }

  addItems(itemsSelecionado: ItemDeNotaFormDTO) {
    this.selectedItems.push(itemsSelecionado);
    this.atualizarValores();
  }

  updateItem(itemAtualizado: ItemDeNotaFormDTO) {
    // Usar o indice salvo em showSelectItems para evitar colisao quando
    // o mesmo produto foi adicionado mais de uma vez ao carrinho.
    const index = this.editandoItemIdx !== -1
      ? this.editandoItemIdx
      : this.selectedItems.findIndex(x => {
          if (x.itemDeNotaDTO.id && itemAtualizado.itemDeNotaDTO.id) {
            return x.itemDeNotaDTO.id === itemAtualizado.itemDeNotaDTO.id;
          }
          return x.item?.id === itemAtualizado.item?.id;
        });

    if (index !== -1) {
      this.selectedItems[index] = itemAtualizado;
    }

    this.editandoItemIdx = -1;
    this.atualizarValores();
    this.visibleSelectItems = false;
  }

  // Método para incrementar a quantidade do itemDeNotaDTO
  incrementarQuantidade(item: ItemDeNotaFormDTO): void {
    // Em uma compra de fornecedor, não há limite de quantidade pelo saldo de estoque.
    // O propósito da compra é justamente aumentar o estoque.
    item.itemDeNotaDTO.quantidade++;
    this.atualizarValores();
    this.cdr.detectChanges(); // Garante que a UI seja atualizada
  }

  // Método para decrementar a quantidade do itemDeNotaDTO
  decrementarQuantidade(item: ItemDeNotaFormDTO): void {
    if (item.itemDeNotaDTO.quantidade > 1) {
      item.itemDeNotaDTO.quantidade--;
      this.atualizarValores();
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: this.translate.instant('common.atencao'),
        detail: this.translate.instant('fornecedor-compra.mensagens.quantidade_minima'),
      });
    }
    this.cdr.detectChanges();
  }


  // Método para remover um item do selectedItems
  removerItem(item: ItemDeNotaFormDTO): void {
    this.selectedItems = this.selectedItems.filter(i => i !== item);
    this.atualizarValores();
    this.cdr.detectChanges(); // Atualiza a UI
  }

  // Método para atualizar valores totais (caso necessário)
  atualizarValores(): void {
    console.log('Valores atualizados:', this.selectedItems);
  }

  getTotalProdutos(): number {
    return this.selectedItems.reduce((total, item) => {
      if (item.item && item.itemDeNotaDTO) { // Garante que item.item não seja undefined
        return total + (item.itemDeNotaDTO.custoUnitario * item.itemDeNotaDTO.quantidade);
      }
      return total; // Caso `item.item` ou `item.itemDeNotaDTO` seja undefined, não soma nada
    }, 0);
  }

  getTotalDescontos(): number {
    const normalizarTipo = (tipo: any): string => {
      if (!tipo) return 'SEM_DESCONTO';
      if (typeof tipo === 'string') return tipo;
      if (typeof tipo === 'object' && 'enum' in tipo) return tipo.enum;
      return 'SEM_DESCONTO';
    };

    return this.selectedItems.reduce((acc, item) => {
      if (!item?.item) {
        return acc;
      }

      const tipo = normalizarTipo(item.item.tipoDeDesconto);
      const desconto = item.item.desconto ?? 0;
      const custoUnitario = item.itemDeNotaDTO?.custoUnitario ?? 0;
      const qtd = item.itemDeNotaDTO?.quantidade ?? 0;

      if (desconto <= 0 || qtd <= 0) {
        return acc;
      }

      switch (tipo) {
        case 'PERCENTUAL': {
          const valorDesconto = (custoUnitario * desconto) / 100;
          return acc + valorDesconto * qtd;
        }

        case 'VALOR': {
          return acc + desconto * qtd;
        }

        default:
          return acc;
      }
    }, 0);
  }

  getTotalCompra(): number {
    return this.getTotalProdutos() - this.getTotalDescontos();
  }

  async finalizarPedido(): Promise<void> {
    try {
      if (this.selectedItems.length === 0) {
        // alert("O carrinho está vazio. Adicione produtos antes de finalizar.");
        this.messageService.add({
          severity: 'warn',
          summary: this.translate.instant('common.atencao'),
          detail: this.translate.instant('fornecedor-compra.mensagens.carrinho_vazio'),
        });

        return;
      }

      if (!this.selectedFornecedor) {
        this.messageService.add({
          severity: 'warn',
          summary: this.translate.instant('common.atencao'),
          detail: this.translate.instant('fornecedor-compra.mensagens.fornecedor_obrigatorio'),
        });

        return;
      }

      // Garante a cotacao do dia ANTES do pagamento (solicita se nao houver),
      // para o dialogo ja mostrar as taxas reais.
      const cotacao = await this.cotacaoGuard.garantirCotacao({ moeda: this.moedaPadrao?.enum });
      if (!cotacao) {
        return;
      }
      this.carregarCotacoes();

      // Exibe o diálogo de forma de pagamento
      this.mostrarDialogPagamento = true;

    } catch (error) {
      console.error("Erro ao inicializar finalização do pedido:", error);
      // alert("Houve um erro ao preparar o pedido. Por favor, tente novamente.");
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: this.translate.instant('fornecedor-compra.mensagens.erro_preparar_pedido'),
      });

    }
  }

  // Método para fechar o diálogo
  fecharDialogPagamento(): void {
    this.mostrarDialogPagamento = false;
    this.formaPagamentoSelecionada = null; // Reseta a seleção
  }

  /**
   * Busca a cotacao atual da moeda padrao da empresa.
   * Valida defensivamente que, quando a moeda for PESO, a cotacao retornada
   * possui `pesoGuarani > 0` (cotacoes legadas podem nao ter esse campo).
   * Retorna null e exibe toast amigavel quando a cotacao for invalida para
   * a moeda PESO, sinalizando para o fluxo abortar o POST.
   */
  /**
   * Calcula o valor a ser enviado em `valorRecebidoNaConta` para pagamento via conta.
   *
   * Regra (alinhada com backend que grava Baixa.valor direto sem reconverter):
   * - Os valores monetarios da nota (totalCompra, valorTotal, etc.) estao SEMPRE na
   *   moeda padrao da empresa (this.moedaPadrao), nao na moeda da nota.
   * - Se a moeda da conta == moeda padrao da empresa, envia o valor tal qual.
   * - Se diferem, converte da moeda padrao da empresa para a moeda da conta usando
   *   a cotacao ja carregada em memoria.
   */
  private calcularValorRecebidoNaConta(
    valorTotal: number,
    moedaConta: string | undefined,
  ): number {
    const moedaEmpresa = this.moedaPadrao?.enum || 'GUARANI';
    if (!moedaConta || moedaConta === moedaEmpresa) {
      return valorTotal;
    }
    const origemIso = enumMoedaParaIso(moedaEmpresa);
    const destinoIso = enumMoedaParaIso(moedaConta);
    if (!origemIso || !destinoIso) {
      return valorTotal; // fallback defensivo — moeda desconhecida
    }
    // Conversao DIRETA par-a-par (espelha ConversorMoedasUtil.kt do backend).
    return converterDireto(valorTotal, origemIso, destinoIso, {
      cotPYG: this.cotPYG,
      cotBRL: this.cotBRL,
      cotRealGuarani: this.cotRealGuarani,
      cotPesoGuarani: this.cotPesoGuarani,
    });
  }

  async buscarCotacaoId(): Promise<number | null> {
    // Rede de seguranca: se a cotacao sumiu/expirou entre abrir o pagamento e
    // confirmar, solicita de novo. Para PESO o guard exige pesoGuarani > 0.
    const cotacao = await this.cotacaoGuard.garantirCotacao({ moeda: this.moedaPadrao?.enum });
    return cotacao?.id ?? null;
  }

  carregarMoedaPadrao(): void {
    if (!this.idEmpresa) {
      console.error("ID da empresa não encontrado no sessionStorage.");
      return;
    }

    this.empresaConfigService.get(`/configuracaoEmpresa/${this.idEmpresa}`).subscribe({
      next: (res) => {
        const moeda = res?.moeda;
        this.moedaPadrao = moeda;

        // Converter MoedaDTO para ISO code para o componente de pagamento
        // Mapeamento explicito por enum (inclui PESO -> ARS)
        const moedaMap: Record<string, 'BRL' | 'PYG' | 'USD' | 'ARS'> = {
          'REAL': 'BRL',
          'DOLAR': 'USD',
          'GUARANI': 'PYG',
          'PESO': 'ARS',
        };
        const codigoOperacao =
          moeda?.codigoOperacao ??
          (moeda?.enum ? moedaMap[moeda.enum] : undefined) ??
          'PYG';
        this.moedaPadraoISO = codigoOperacao as 'BRL' | 'PYG' | 'USD' | 'ARS';

        // Pre-seleciona formato de impressao da configuracao da empresa
        const formatoImpressao = (res as any)?.tipoDeFormatoDaImpressao?.enum
          ?? (res as any)?.tipoDeFormatoDaImpressao;
        if (formatoImpressao === 'BOBINA_58' || formatoImpressao === 'BOBINA_80' || formatoImpressao === 'A4') {
          this.opcaoImpressaoFatura = formatoImpressao;
        }

        // Carrega opcao de impressao automatica da empresa
        const rawTipoImprimir = (res as any)?.tipoImprimir;
        this.tipoImprimir = typeof rawTipoImprimir === 'string'
          ? rawTipoImprimir
          : rawTipoImprimir?.tipoEnum ?? rawTipoImprimir?.enum ?? 'PERGUNTAR';

        // Carregar cotações após obter a moeda padrão
        this.carregarCotacoes();
      },
      error: (err) => {
        console.error('Erro ao buscar configuração da empresa:', err);
        this.moedaPadraoISO = 'BRL';
      },
    });
  }

  // Método para abrir o modal de confirmação
  abrirConfirmacaoCancelarPedido(): void {
    this.confirmationService.confirm({
      message: this.translate.instant('fornecedor-compra.mensagens.confirmar_cancelar_pedido'),
      acceptLabel: this.translate.instant('common.sim'),
      rejectLabel: this.translate.instant('common.nao'),
      accept: () => this.cancelarPedido(), // Ação ao confirmar
    });
  }

  // Método para limpar os dados
  cancelarPedido(): void {
    this.selectedFornecedor = undefined;
    if (this.fornecedorSelector) {
      this.fornecedorSelector.clear();
    }
    this.selectedItems = [];
    this.notaForm = this.createEmptyNotaForm();
    this.faturaLegal = [];
    this.formaPagamentoSelecionada = null;
  }

  async criarNotaFinal(): Promise<any> {
    const agora = new Date();
    const totalCompra = this.getTotalCompra();

    const notaFinal: any = {
      emissao: toLocalISOString(agora),
      emissaoFatura: toLocalISOString(agora),
      tipoDeTransacao: 'COMPRA',
      ehFaturaLegal: this.notaForm.ehFaturaLegal ?? false,
      numeroFatura: this.notaForm.ehFaturaLegal ? (this.notaForm.numeroFatura ?? null) : null,
      numeroPontoExpedicao: this.notaForm.ehFaturaLegal ? (this.notaForm.numeroPontoExpedicao ?? null) : null,
      numeroFilial: this.notaForm.ehFaturaLegal ? (this.notaForm.numeroFilial ?? null) : null,
      tipoNota: 'MANUAL',
      condicaoDePagamento: '',
      conta_id: null,
      moedaDaConta: null,
      cotacao_id: undefined,
      custoTotalDosItens: totalCompra,
      valorTotal: totalCompra,
      valorDoDesconto: 0,
      tipoDeDesconto: 'SEM_DESCONTO',
      porcentagemDesconto: 0,
      valorTotalComDesconto: totalCompra,
      valorRecebidoNaConta: 0,
      valorRecebidoEmGuarani: 0,
      valorRecebidoEmDolar: 0,
      valorRecebidoEmReal: 0,
      informacaoDaTransacao: '',
      moeda: '',
      cancelado: false,
      pessoa_id: this.selectedFornecedor?.id || null,
      vendedor_id: null,
      timbrado_id: null,
      numeroTimbrado: null,
      observacao: this.notaForm.observacao ?? '',
      itemDeNota: [],
      valorTotalEmServicos: 0,
      valorTotalEmMercadorias: totalCompra,
      chaveNotaEletronica: '',
      baixas: [],
      titulos: [],
      numeroParcelas: 0,
    };

    try {
      // Obter o ID do vendedor do sessionStorage
      const usuarioId = this.safe.getItem("userId");
      if (!usuarioId) throw new Error("ID do usuário não encontrado no sessionStorage.");

      // Buscar o `pessoa_id` do usuário
      const usuario = await this.usuarioService.get(`/usuario/${usuarioId}`).toPromise();
      const vendedorPessoaId = (usuario as any)?.pessoa?.id;
      if (!vendedorPessoaId) throw new Error("Pessoa ID do vendedor não encontrado.");

      // Definir `vendedor_id` no `notaFinal`
      notaFinal.vendedor_id = vendedorPessoaId;

      // Buscar a `empresaId` do vendedor
      const pessoa = await this.pessoaService.get(`/pessoas/${vendedorPessoaId}`).toPromise();
      const empresaId = (pessoa as any)?.empresaId; // Use "as any" para ignorar a validação
      if (!empresaId) throw new Error("Empresa ID não encontrada para o vendedor.");

      // Buscar a `moeda` da empresa
      const configuracaoEmpresa = await this.empresaConfigService.get(`/configuracaoEmpresa/${empresaId}`).toPromise();
      notaFinal.moeda = (configuracaoEmpresa as any)?.moeda?.enum || this.moedaPadrao?.enum || "GUARANI";

      return notaFinal;
    } catch (error) {
      console.error("Erro ao construir o objeto notaFinal:", error);
      throw error; // Rejeita a promessa em caso de erro
    }
  }

  carregarContas(): void {
    // Filtra apenas contas do tipo BANCO, pois no contexto de compras de fornecedor
    // apenas transferencias bancarias sao suportadas como forma de pagamento em conta.
    this.contaService.get('/conta?tipoConta=BANCO').subscribe({
      next: (res) => {
        if (res?.content && Array.isArray(res.content)) {
          this.contasFormatadas = res.content.map((conta: any) => ({ label: conta.tituloDaConta, value: conta }));
        } else {
          this.contasFormatadas = [];
        }
      },
      error: () => (this.contasFormatadas = []),
    });
  }

  carregarCotacoes(): void {
    const moedaEnum = this.moedaPadrao?.enum || 'GUARANI';
    this.cotacaoService.get(`/cotacao/cotacaoAtual?moedaPadrao=${moedaEnum}`).subscribe({
      next: (res: any) => {
        if (res) {
          this.cotPYG = res.dolarGuarani || 7180;
          this.cotBRL = res.dolarReal || 5.47;
          // pesoGuarani e opcional; sem valor, coluna peso permanece oculta
          this.cotPesoGuarani = res.pesoGuarani || 0;
          // realGuarani: cotacao direta BRL->PYG; 0 = fallback triangulacao
          this.cotRealGuarani = res.realGuarani || 0;
        }
      },
      error: () => {
        // Manter valores padrao
      },
    });
  }

  async onPagamentoConfirmado(result: FormaPagamentoResult): Promise<void> {
    if (this.processandoCompra) return;

    // Recarregar config de impressao da empresa (pode ter mudado sem F5)
    try {
      const configRes: any = await firstValueFrom(this.empresaConfigService.get(`/configuracaoEmpresa/${this.idEmpresa}`));
      const rawTipoImprimir = configRes?.tipoImprimir;
      this.tipoImprimir = typeof rawTipoImprimir === 'string'
        ? rawTipoImprimir
        : rawTipoImprimir?.enum ?? rawTipoImprimir?.tipoEnum ?? 'PERGUNTAR';
      const formatoImpressao = configRes?.tipoDeFormatoDaImpressao?.enum ?? configRes?.tipoDeFormatoDaImpressao;
      if (formatoImpressao === 'BOBINA_58' || formatoImpressao === 'BOBINA_80' || formatoImpressao === 'A4') {
        this.opcaoImpressaoFatura = formatoImpressao;
      }
    } catch (e) { /* usa valor em memoria se falhar */ }

    try {
      this.processandoCompra = true;
      const notaFinal = await this.criarNotaFinal();

      // Calcular total da compra
      const totalCompra = this.getTotalCompra();
      notaFinal.valorTotalComDesconto = totalCompra;

      // Gerar itens de nota (alinhado com o fluxo do mobile)
      notaFinal.itemDeNota = this.selectedItems.map((item: any) => {
        const quantidade = item.itemDeNotaDTO.quantidade;
        const valorTotal = item.itemDeNotaDTO.valorTotal || 0;
        const desconto = item.itemDeNotaDTO.desconto || 0;
        const novoPrecoVenda = item.itemDeNotaDTO.novoPrecoVenda;

        // Custo unitario = custo real (valor total / quantidade)
        const custoUnitario = quantidade > 0 ? valorTotal / quantidade : 0;
        const custoTotal = valorTotal;

        // Preco de venda (valorUnitario no contexto da nota)
        const valorUnitario = novoPrecoVenda || item.item?.precoDeVenda || custoUnitario;

        // Calcular desconto (suporte a PERCENTUAL e VALOR, igual ao mobile)
        const tipoDeDesconto = item.itemDeNotaDTO.tipoDeDesconto?.enum
          ?? item.itemDeNotaDTO.tipoDeDesconto
          ?? item.item?.tipoDeDesconto?.enum
          ?? 'SEM_DESCONTO';

        let valorUnitarioComDesconto = custoUnitario;
        let valorTotalComDesconto = valorTotal;

        if (tipoDeDesconto === 'PERCENTUAL' && desconto > 0) {
          valorUnitarioComDesconto = custoUnitario - (custoUnitario * desconto / 100);
          valorTotalComDesconto = valorTotal - (valorTotal * desconto / 100);
        } else if (tipoDeDesconto === 'VALOR' && desconto > 0) {
          valorUnitarioComDesconto = custoUnitario - desconto;
          valorTotalComDesconto = valorUnitarioComDesconto * quantidade;
        }

        // Extrair tipoDeImposto
        const tipoDeImposto = item.itemDeNotaDTO.tipoDeImposto?.enum ??
                              item.itemDeNotaDTO.tipoDeImposto ??
                              item.item?.tipoDeImposto?.enum ??
                              item.item?.tipoDeImposto;

        // Calcular bases de IVA baseado no tipoDeImposto
        let valorBaseIVA10 = 0;
        let valorBaseIVA5 = 0;
        let valorBaseIVA0 = 0;
        let valorIVA10 = 0;
        let valorIVA5 = 0;
        let valorIVA0 = 0;

        if (tipoDeImposto === 'IVA_10') {
          valorBaseIVA10 = valorTotalComDesconto / 1.1;
          valorIVA10 = valorTotalComDesconto - valorBaseIVA10;
        } else if (tipoDeImposto === 'IVA_5') {
          valorBaseIVA5 = valorTotalComDesconto / 1.05;
          valorIVA5 = valorTotalComDesconto - valorBaseIVA5;
        } else {
          valorBaseIVA0 = valorTotalComDesconto;
          valorIVA0 = 0;
        }

        return {
          item_id: item.item?.id,
          quantidade: quantidade,
          valorUnitario: custoUnitario,
          custoUnitario: custoUnitario,
          custoTotal: custoTotal,
          valorTotal: valorTotal,
          desconto: desconto,
          valorUnitarioComDesconto: valorUnitarioComDesconto,
          valorTotalComDesconto: valorTotalComDesconto,
          tipoDeImposto: tipoDeImposto,
          valorBaseIVA10: valorBaseIVA10,
          valorBaseIVA5: valorBaseIVA5,
          valorBaseIVA0: valorBaseIVA0,
          valorIVA10: valorIVA10,
          valorIVA5: valorIVA5,
          valorIVA0: valorIVA0,
          precoDeVendaNovo: novoPrecoVenda,
          observacao: item.itemDeNotaDTO.observacao || '',
        };
      });

      // Preencher pessoa (fornecedor)
      if (this.selectedFornecedor) {
        notaFinal.pessoa_id = this.selectedFornecedor.id;
      }

      // Buscar cotacao_id uma unica vez para qualquer forma de pagamento.
      // Quando a moeda for PESO, buscarCotacaoId valida pesoGuarani > 0.
      // Se retornar null, aborta o POST exibindo toast.
      const cotacaoId = await this.buscarCotacaoId();
      if (cotacaoId == null) {
        // Aborta o POST: toast ja foi exibido por buscarCotacaoId().
        // processandoCompra sera resetado pelo bloco finally.
        return;
      }
      notaFinal.cotacao_id = cotacaoId;

      if (result.forma === 'dinheiro') {
        const dados = result.dados as DadosPagamentoDinheiro;
        notaFinal.condicaoDePagamento = 'CONTADO';
        notaFinal.valorRecebidoEmGuarani = dados.valorRecebidoEmGuarani || 0;
        notaFinal.valorRecebidoEmDolar = dados.valorRecebidoEmDolar || 0;
        notaFinal.valorRecebidoEmReal = dados.valorRecebidoEmReal || 0;
        notaFinal.valorRecebidoEmPeso = dados.valorRecebidoEmPeso || 0;
        notaFinal.valorRecebidoNaConta = 0;
        notaFinal.numeroParcelas = 0;
        notaFinal.titulos = [];
      }

      if (result.forma === 'conta') {
        const dados = result.dados as DadosPagamentoConta;
        notaFinal.condicaoDePagamento = 'CONTADO';
        // Backend grava Baixa.valor = valorRecebidoNaConta direto (sem reconverter).
        // Origem da conversao = moeda padrao da empresa (todos os valor* da nota
        // estao nessa moeda). Converte direto par-a-par quando a moeda da conta diferir.
        //
        // Guard de pareamento: a conversao direta proibe ARS<->USD/BRL (espelha o
        // backend). Valida ANTES do POST e aborta com toast caso a conta escolhida
        // seja incompativel — nao usa excecao como fluxo. processandoCompra e
        // resetado pelo bloco finally.
        const moedaEmpresaEnum = this.moedaPadrao?.enum || 'GUARANI';
        if (dados.moedaDaConta && !podeConverterEntre(moedaEmpresaEnum, dados.moedaDaConta)) {
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('forma_pagamento.moeda_incompativel_titulo'),
            detail: this.translate.instant('forma_pagamento.moeda_incompativel_detalhe'),
          });
          return;
        }
        // Defesa em profundidade: a excecao de par proibido nunca deve quebrar a tela.
        try {
          notaFinal.valorRecebidoNaConta = this.calcularValorRecebidoNaConta(
            totalCompra,
            dados.moedaDaConta,
          );
        } catch (erroConversao) {
          if (erroConversao instanceof ConversaoNaoPermitidaError) {
            this.messageService.add({
              severity: 'warn',
              summary: this.translate.instant('forma_pagamento.moeda_incompativel_titulo'),
              detail: this.translate.instant('forma_pagamento.moeda_incompativel_detalhe'),
            });
            return;
          }
          throw erroConversao;
        }
        notaFinal.conta_id = dados.conta_id;
        notaFinal.moedaDaConta = dados.moedaDaConta;
        notaFinal.informacaoDaTransacao = dados.informacaoDaTransacao;
        notaFinal.valorRecebidoEmGuarani = 0;
        notaFinal.valorRecebidoEmDolar = 0;
        notaFinal.valorRecebidoEmReal = 0;
        notaFinal.valorRecebidoEmPeso = 0;
        notaFinal.numeroParcelas = 0;
        notaFinal.titulos = [];
      }

      if (result.forma === 'prazo') {
        const dados = result.dados as DadosPagamentoPrazo;
        notaFinal.condicaoDePagamento = 'CREDITO';
        notaFinal.numeroParcelas = dados.numeroParcelas;
        notaFinal.titulos = dados.titulos.map(t => ({ ...t, tipoOperacaoFinanceira: 'SAIDA' }));
        notaFinal.valorRecebidoEmGuarani = 0;
        notaFinal.valorRecebidoEmDolar = 0;
        notaFinal.valorRecebidoEmReal = 0;
        notaFinal.valorRecebidoEmPeso = 0;
        notaFinal.valorRecebidoNaConta = 0;
      }

      // Enviar nota para o backend
      this.notaService.post('/nota', notaFinal as any).subscribe({
        next: (respostaNota: any) => {
          this.mostrarDialogPagamento = false;
          this.cancelarPedido();
          // Abrir dialogo de fatura pos-compra
          if (respostaNota?.id) {
            this.carregarNotaCompleta(respostaNota.id);
          }
        },
      });
    } catch (error: any) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('erro'),
        detail: this.translate.instant('fornecedor-compra.mensagens.erro_compra'),
      });
    } finally {
      this.processandoCompra = false;
    }
  }

  private obterNomeMoeda(moeda: any): string | null {
    return moeda?.enum ?? null;
  }

  getValorDescontoItem(item: ItemDTO): number {
    if (!item) return 0;

    const normalizarTipo = (tipo: any): string => {
      if (!tipo) return 'SEM_DESCONTO';
      if (typeof tipo === 'string') return tipo;
      if (typeof tipo === 'object' && 'enum' in tipo) return tipo.enum;
      return 'SEM_DESCONTO';
    };

    const tipo = normalizarTipo(item.tipoDeDesconto);
    const desconto = item.desconto ?? 0;
    const precoVenda = item.precoDeVenda ?? 0;

    if (desconto <= 0) return 0;

    switch (tipo) {
      case 'PERCENTUAL':
        return (precoVenda * desconto) / 100;

      case 'VALOR':
        return desconto;

      default:
        return 0;
    }
  }

  formatarValorMonetario(valor: number, moeda?: MoedaDTO): string {
    if (valor == null || isNaN(valor)) return '-';

    if (!moeda) {
      moeda = this.moedaPadrao;
    }

    const configuracoesMoeda: Record<Moeda, { locale: string; simbolo: string }> = {
      [Moeda.GUARANI]: { locale: 'es-PY', simbolo: 'Gs' },
      [Moeda.REAL]: { locale: 'pt-BR', simbolo: 'R$' },
      [Moeda.DOLAR]: { locale: 'en-US', simbolo: '$' },
      [Moeda.PESO]: { locale: 'es-AR', simbolo: '$' },
    };

    const nomeMoeda = this.obterNomeMoeda(moeda) as Moeda;
    const { locale, simbolo } = configuracoesMoeda[nomeMoeda] ?? configuracoesMoeda[Moeda.GUARANI];

    const isGuarani = nomeMoeda === Moeda.GUARANI;

    const options: Intl.NumberFormatOptions = isGuarani
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 };

    const valorFormatado = new Intl.NumberFormat(locale, options).format(valor);

    return `${simbolo} ${valorFormatado}`;
  }

  // ========================================================================
  // Dialogo Fatura Pos-Compra
  // ========================================================================

  carregarNotaCompleta(idNota: number): void {
    this.carregandoFatura = true;

    // Para PERGUNTAR, NADA_A_FAZER e IMPRIMIR, abre o dialog para exibir a fatura
    this.mostrarDialogoFatura = true;

    this.notaService.get(`/nota/${idNota}`).subscribe({
      next: (response: any) => {
        this.notaCarregada = this.mapNotaDialogo(response);
        this.loadItensDoDialogo(this.notaCarregada.itemDeNota);

        // IMPRIMIR: imprimir automaticamente no formato padrao apos carregar nota
        if (this.tipoImprimir === 'IMPRIMIR') {
          setTimeout(() => this.imprimirAutomatico(), 500);
        }
      },
      error: () => {
        this.carregandoFatura = false;
        this.mostrarDialogoFatura = false;
      }
    });
  }

  private mapNotaDialogo(response: any): NotaDTO {
    return {
      id: response.id,
      emissao: response.emissao,
      emissaoFatura: response.emissaoFatura,
      codigoNota: response.codigoNota,
      tipoDeTransacao: response.tipoDeTransacao?.enum,
      ehFaturaLegal: response.ehFaturaLegal,
      numeroFatura: response.numeroFatura ?? 0,
      numeroPontoExpedicao: response.numeroPontoExpedicao ?? 0,
      valorCotacaoParaGuarani: response.valorCotacaoParaGuarani,
      valorTotalEmGuarani: response.valorTotalEmGuarani ?? 0,
      numeroFilial: response.numeroFilial ?? 0,
      numeroTimbrado: response.numeroTimbrado ?? '',
      chaveNotaEletronica: response.chaveNotaEletronica ?? '',
      valorTotalEmServicos: response.valorTotalEmServicos,
      valorTotalEmMercadorias: response.valorTotalEmMercadorias,
      timbrado_id: response.timbrado?.id ?? 0,
      tipoNota: response.tipoNota?.enum,
      condicaoDePagamento: response.condicaoDePagamento?.enum,
      conta_id: response.conta?.id ?? 0,
      moedaDaConta: response.moedaDaConta?.enum,
      cotacao_id: response.cotacao?.id ?? 0,
      custoTotalDosItens: response.custoTotalDosItens,
      valorTotal: response.valorTotal,
      valorTotalComDesconto: response.valorTotalComDesconto,
      valorDoDesconto: response.valorDoDesconto,
      tipoDeDesconto: response.tipoDeDesconto?.enum,
      porcentagemDesconto: response.porcentagemDesconto,
      valorRecebidoNaConta: response.valorRecebidoNaConta,
      valorRecebidoEmGuarani: response.valorRecebidoEmGuarani,
      valorRecebidoEmDolar: response.valorRecebidoEmDolar,
      valorRecebidoEmReal: response.valorRecebidoEmReal,
      informacaoDaTransacao: response.informacaoDaTransacao,
      moeda: response.moeda?.enum,
      valorBASEIVA10: response.valorBASEIVA10,
      valorIVA10: response.valorIVA10,
      valorBASEIVA5: response.valorBASEIVA5,
      valorIVA5: response.valorIVA5,
      valorBASEIVA0: response.valorBASEIVA0,
      valorIVA0: response.valorIVA0,
      valorTotalDoImposto: response.valorTotalDoImposto,
      cancelado: response.cancelado,
      observacao: response.observacao ?? '',
      empresaId: response.empresaId,
      criadoEm: response.criadoEm,
      atualizadoEm: response.atualizadoEm,
      pessoa_id: response.pessoa?.id ?? 0,
      nomePessoa: response.nomePessoa ?? '',
      vendedor_id: response.vendedor?.id ?? 0,
      nomeVendedor: response.nomeVendedor ?? '',
      itemDeNota: response.itemDeNota ?? [],
      baixas: response.baixas ?? [],
      titulos: response.titulos ?? [],
      numeroParcelas: response.numeroParcelas ?? 0,
    };
  }

  private loadItensDoDialogo(itensDeNota: ItemDeNotaDTO[]): void {
    if (!itensDeNota || itensDeNota.length === 0) {
      this.itensCarregados = [];
      this.carregandoFatura = false;
      return;
    }

    const requisicoes = itensDeNota.map(item =>
      item.item_id
        ? this.itemsService.getById('/item', item.item_id.toString())
        : of(null as any)
    );

    forkJoin(requisicoes).subscribe({
      next: (response: (ItemDTO | null)[]) => {
        this.itensCarregados = response.map(r => r ?? ({ nome: '---', imagem: '' } as any));
        this.carregandoFatura = false;
      },
      error: () => {
        this.itensCarregados = [];
        this.carregandoFatura = false;
      }
    });
  }

  formatarDataEHoraDialog(dataISO: string): string {
    if (!dataISO) return '';
    const data = new Date(dataISO);
    if (isNaN(data.getTime())) return '';
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    const horas = String(data.getHours()).padStart(2, '0');
    const minutos = String(data.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
  }

  formatarValorDialog(valor: number, moedaEnum?: string): string {
    if (valor == null || isNaN(valor)) return '-';

    const configuracoesMoeda: Record<string, { locale: string; simbolo: string }> = {
      'GUARANI': { locale: 'es-PY', simbolo: 'Gs' },
      'REAL': { locale: 'pt-BR', simbolo: 'R$' },
      'DOLAR': { locale: 'en-US', simbolo: '$' },
      'PESO': { locale: 'es-AR', simbolo: '$' },
    };

    const nomeMoeda = moedaEnum || this.moedaPadrao?.enum || 'GUARANI';
    const { locale, simbolo } = configuracoesMoeda[nomeMoeda] ?? configuracoesMoeda['GUARANI'];
    const isGuarani = nomeMoeda === 'GUARANI';
    const options: Intl.NumberFormatOptions = isGuarani
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    const valorFormatado = new Intl.NumberFormat(locale, options).format(valor);
    return `${simbolo} ${valorFormatado}`;
  }

  formatarCondicaoPagamento(condicao: string): string {
    if (!condicao) return '-';
    return this.translate.instant(`enums.condicao_de_pagamento.${condicao}`);
  }

  fecharDialogoFatura(): void {
    this.mostrarDialogoFatura = false;
    this.notaCarregada = null;
    this.itensCarregados = [];
  }

  private imprimirAutomatico(): void {
    if (!this.notaCarregada?.id) return;

    const formato = this.opcaoImpressaoFatura || 'BOBINA_58';

    this.notaService.gerarPdfNota(`/nota/gerar-pdf-nota/${this.notaCarregada.id}/impressao/${formato}`).subscribe({
      next: (pdfBase64: string) => {
        if (!pdfBase64) return;

        const byteCharacters = atob(pdfBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        let iframe = document.getElementById('avati-iframe-impressao') as HTMLIFrameElement;
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.id = 'avati-iframe-impressao';
          iframe.style.display = 'none';
          document.body.appendChild(iframe);
        }
        iframe.src = url;
        iframe.onload = () => {
          try { iframe.contentWindow?.print(); }
          catch (e) { window.open(url, '_blank'); }
        };
      },
    });
  }

  gerarPdfFaturaDialog(): void {
    if (!this.notaCarregada?.id) return;

    const formato = this.opcaoImpressaoFatura || 'A4';

    // Abrir janela ANTES da chamada HTTP para evitar bloqueio de popup
    const janela = window.open('about:blank', '_blank');
    this.isImprimindoFatura = true;

    this.notaService.gerarPdfNota(`/nota/gerar-pdf-nota/${this.notaCarregada.id}/impressao/${formato}`).subscribe({
      next: (pdfBase64: string) => {
        this.isImprimindoFatura = false;
        if (pdfBase64) {
          this.exibirPdf(pdfBase64, janela);
        } else {
          if (janela && !janela.closed) janela.close();
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('erro'),
            detail: this.translate.instant('fornecedor-compra.mensagens.erro_gerar_pdf')
          });
        }
      },
      error: () => {
        this.isImprimindoFatura = false;
        if (janela && !janela.closed) janela.close();
      }
    });
  }

  private exibirPdf(pdfBase64: string, janela?: Window | null): void {
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    if (janela && !janela.closed) {
      janela.location.href = url;
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    }
  }

}
